<template>
  <swiper :options="swiperOption">
    <swiper-slide class="list1" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step1.exact.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step1.exact.desc')"></li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide class="list2" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step1.simple.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step1.simple.desc')"></li>
            <li class="desc">{{ $t('page.registration.guide.limitAB') }}</li>
          </ul>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide class="list3" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step1.starts.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step1.starts.desc')"></li>
            <li class="desc">{{ $t('page.registration.guide.limitAB') }}</li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide class="list4" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step1.ends.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step1.ends.desc')"></li>
            <li class="desc">{{ $t('page.registration.guide.limitAB') }}</li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide class="list5" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step1.contains.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step1.contains.desc')"></li>
            <li class="desc">{{ $t('page.registration.guide.limitAB') }}</li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide class="list6" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step1.regExp.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step1.regExp.desc')"></li>
            <li class="desc">{{ $t('page.registration.guide.limitAB') }}</li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide class="list7" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step1.setURL.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step1.setURL.desc')"></li>
          </ul>
        </div>
        <figure class="img--wrap"></figure>
        <p class="figcaption">
          <span class="first-text" v-html="$t('common.uxAnalysisImage')"></span>
          <span class="second-text" v-html="$t('common.heatmapImage')"></span>
          <span class="third-text" v-html="$t('common.captureImage')"></span>
        </p>
      </div>
    </swiper-slide>
    <swiper-slide class="list8" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step1.bLogin.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step1.bLogin.desc')"></li>
            <li class="desc bLogin" v-html="$t('page.registration.guide.step1.bLogin.desc2')"></li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide class="list9" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step1.device.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step1.device.desc')"></li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination" ref="pagination"></div>
    <div class="swiper-button-prev icon icon--prev-white-size20" slot="button-prev"></div>
    <div class="swiper-button-next icon icon--prev-white-size20" slot="button-next"></div>
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  props: [
    'focusContent'
  ],
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  watch: {
    focusContent () {
      if (this.focusContent.currentStep === 2) {
        const contentIndex = this.focusContent.currentContentIndex
        this.$refs.pagination.children[contentIndex].click()
      }
    }
  }
}
</script>
